import $ from 'jquery';
import 'slick-carousel';

// Home Hero Slider
const $homeHeroSlider = $('.home-hero-slider');

const consistentHeight = $homeHeroSlider.data('consistentHeight') ?? false;

// Applies a base theme (group of classes) to the indvidual slider dots
$homeHeroSlider.on('init', function (event, slick) {
  if (slick.$dots) {
    const dots = slick.$dots.find('li');
    const theme = $('.slide-m-dots-home-hero-slider').data('theme');
    if (theme) {
      dots.addClass(theme);
    }
  }
});

// Initialize Hero Slider
$homeHeroSlider.slick({
  lazyLoad: 'progressive',
  slidesToShow: 1,
  slidesToScroll: 1,
  infinite: true,
  arrows: true,
  dots: true,
  adaptiveHeight: !consistentHeight,
  appendDots: $('.slide-m-dots-home-hero-slider'),
  nextArrow: $('.slide-m-next-home-hero-slider'),
  prevArrow: $('.slide-m-prev-home-hero-slider'),
});

if (consistentHeight) {
  $homeHeroSlider.on('setPosition', function (e, slick) {
    slick.$slides.css('height', slick.$slideTrack.height() + 'px');
  });
} else {
  $homeHeroSlider.on('init postChange', function(event, slick) {
  slick.setPosition();
});
}



const isAutoscroll = $homeHeroSlider.data('autoscroll');

// console.log('do we auto scroll', isAutoscroll);

if (isAutoscroll == 1) {
  // Hero Slider Auto Play ( if enabled by acf ) | false
  const duration = $homeHeroSlider.data('duration'); // collects from ACF (May) | 9000
  const RESTART = $homeHeroSlider.data('restart'); // collects from ACF (May) | false
  const $nextSlideButton = $('.hero-slider-controls .slide-m-next-home-hero-slider');
  let isPaused = true;
  let SLIDER_INTERVAL = 0;
  const initializedVideos = [];
  let APIReady = false;
  const ytPLAYERS = {};

  $homeHeroSlider.on('afterChange', function (event, slick, currentSlide) {
    // console.log('AFTER CHANGE FIRED', currentSlide);
    runSlideProgram(currentSlide);
  });

  $homeHeroSlider.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
    // console.log('BEFORE CHANGE FIRED', currentSlide);
    runVideoPause(currentSlide);
  });

  // check if slider is set to restart at this slide
  function checkReplay(slideToCheck, duration = duration) {
    slideToCheck = slideToCheck + 1;
    if (RESTART) {
      // console.log('CHECKING SLIDE: ', slideToCheck);
      if (RESTART <= slideToCheck) {
        // console.log('RESTART NEEDED>>>>>>>>, going to first');
        setTimeout(function () {
          $homeHeroSlider.slick('slickGoTo', 0, true);
        }, duration);
        return true;
      }
    }
  }

  function runVideoPause(currentSlide) {
    pauseSlider();
    const video = thisSlideVideo();
    if (video) {
      const type = getVideoType(video);
      if (type == 'youtube') {
        try {
          const playerState = ytPLAYERS[currentSlide].getPlayerState();
          if (playerState !== 0) {
            // console.log('YT video is playing on this slide, pausing video ||');
            ytPLAYERS[currentSlide].pauseVideo();
          }
        } catch (err) {
        //   console.log('threw error on slide: ', currentSlide, ytPLAYERS);
        }
      } else {
        // console.log('uploaded video is playing on this slide, pausing video ||');
        video[0].pause();
      }
    }
  }

  function runSlideProgram(currentSlide) {
    // console.log('runSlideProgram: check slide for video');
    pauseSlider();
    const video = thisSlideVideo();
    // console.log('detected video: ', video);
    if (video) {
      const type = getVideoType(video);
      runVideoSlideProgram(type, video[0], currentSlide);
    } else {
      resumeSlider(currentSlide);
    }
  }

  function pauseSlider() {
    if (SLIDER_INTERVAL != 0) {
      // console.log('PAUSING interval ID: ', SLIDER_INTERVAL);
      isPaused = true;
      clearInterval(SLIDER_INTERVAL);
      SLIDER_INTERVAL = 0;
    }
  }

  function resumeSlider(currentSlide, forVideo = false) {
    if (!checkReplay(currentSlide, forVideo ? 500 : duration)) {
      isPaused = false;
      if (forVideo) {
        $nextSlideButton.trigger('click');
      }
      startSliderAutoScroll();
    }
  }

  function getVideoType(video) {
    return video.hasClass('video-youtube') ? 'youtube' : 'upload';
  }

  function holdScroll(video) {
    if (video) {
      const sync = video.data('sync');
      return sync == 1 ? false : true;
    } else {
      return false;
    }
  }

  function startSliderAutoScroll() {
    // console.log('starting slider auto scroll >>>');
    // clear any previous intervals
    if (SLIDER_INTERVAL != 0) {
      clearInterval(SLIDER_INTERVAL);
      SLIDER_INTERVAL = 0;
    }
    // start new interval
    SLIDER_INTERVAL = setInterval(function () {
      if (!isPaused) {
        $nextSlideButton.trigger('click');
      }
    }, duration);
    // console.log('STARTING interval ID: ', SLIDER_INTERVAL);
  }

  // check for vide in current slide
  function thisSlideVideo() {
    const $thisHeroSlide = $homeHeroSlider.find('.slick-slide.slick-current');
    const $videoInThisSlide = $thisHeroSlide.find('.home-hero-video');
    return $videoInThisSlide.length != 0 ? $videoInThisSlide : false;
  }

  function runVideoSlideProgram(type, video, currentSlide) {
    if (type == 'upload') {
      uploadVideoHandler(video, currentSlide);
    } else if (type == 'youtube') {
      ytVideoHandler(video, currentSlide);
    }
  }

  function uploadVideoHandler(video, currentSlide) {
    // console.log('uploaded video start play');
    video.play();
    const hold = holdScroll($(video));
    if (hold) {
    //   console.log('hold autoscroll for video ', hold);
      video.addEventListener('ended', function () {
        // console.log('uploaded Video ENDED');
        video.currentTime = 0;
        if (hold) {
          resumeSlider(currentSlide, true);
        } else {
          video.play();
          isPaused = false;
          startSliderAutoScroll();
        }
      });
    } else {
      setTimeout(function () {
        isPaused = false;
        startSliderAutoScroll();
      }, duration);
    }
  }

  function ytVideoHandler(video, currentSlide) {
    // console.log('createPlayerHandler called for slide', currentSlide);
    const videoId = video.getAttribute('data-video-id');
    const hold = holdScroll($(video));

    if (initializedVideos.includes(currentSlide)) {
    //   console.log('playing the existing video');
      ytPLAYERS[currentSlide].playVideo();
      if (!hold) {
        // console.log('do not hold video: ', hold);
        isPaused = false;
        startSliderAutoScroll();
      }
    } else if (APIReady) {
    //   console.log('THIS video player needs to be initialized, creating player');
      ytPLAYERS[currentSlide] = new window.YT.Player(video, {
        videoId: videoId,
        playerVars: {
          autoplay: 1,
          modestbranding: 1,
          rel: 0,
        },
        events: {
          onReady: onPlayerReady,
          onStateChange: onPlayerStateChange,
          onError: onPlayerError,
        },
      });
      initializedVideos.push(currentSlide);
    }

    let youtubeScriptId = 'youtube-api';
    let youtubeScript = document.getElementById(youtubeScriptId);

    if (youtubeScript === null) {
    //   console.log('creating API script tag!!');
      let tag = document.createElement('script');
      let firstScript = document.getElementsByTagName('script')[0];

      tag.src = 'https://www.youtube.com/iframe_api';
      tag.id = youtubeScriptId;
      firstScript.parentNode.insertBefore(tag, firstScript);
    }

    // runs only on first video
    window.onYouTubeIframeAPIReady = function () {
    //   console.log('API is Ready, creating player');
      ytPLAYERS[currentSlide] = new window.YT.Player(video, {
        videoId: videoId,
        playerVars: {
          autoplay: 1,
          modestbranding: 1,
          rel: 0,
        },
        events: {
          onReady: onPlayerReady,
          onStateChange: onPlayerStateChange,
          onError: onPlayerError,
        },
      });
      initializedVideos.push(currentSlide);
      APIReady = true;
    };

    function onPlayerReady(event) {
    //   console.log('onPlayerReady');
      event.target.playVideo();
      if (!hold) {
        // console.log('do not hold for video: ', hold);
        isPaused = false;
        startSliderAutoScroll();
      }
    }

    function onPlayerError(event) {
      console.log('onPlayerError');
    }

    function onPlayerStateChange(event) {
      const state = event.data;
      if (state === YT.PlayerState.ENDED) {
        // console.log('⏸️ Video ENDED');
        if (!hold) {
          event.target.playVideo();
          isPaused = false;
          startSliderAutoScroll();
        } else {
          resumeSlider(currentSlide, true);
        }
      } else if (state === YT.PlayerState.PAUSED) {
        // console.log('⏸️ Video paused');
      } else if (state === YT.PlayerState.PLAYING) {
        // console.log('▶️ Video playing');
      }
    }
  }

  $(window).on('load', function () {
    // start auto-scroll program on page load
    startSliderAutoScroll();
    // first slide as assumed default
    runSlideProgram(0);
  });
}
